import { darkTheme as apolloDarkTheme } from 'material-ui-apollo';
import { mergeDeepLeft } from 'ramda';

import { appTheme } from './appTheme';

const darkTheme = mergeDeepLeft(apolloDarkTheme, appTheme); //local theme overrides take precedence

export default darkTheme;



// WEBPACK FOOTER //
// ./src/Shared/Themes/darkTheme.js